import useSWRImmutable from 'swr/immutable'
import { customNoAuthAxios } from "../../utils/customNoAuthAxios";


export const useSwrImmutableNoAuth = <T = any>(url: string | null) => {
  const fetcher = (url: string) => customNoAuthAxios.get(url).then(res => res.data);
  const { data, error, isLoading, isValidating } = useSWRImmutable<T>(url ? url : null, fetcher);
  return { data, error, isLoading, isValidating };
};